import { render, staticRenderFns } from "./triage.vue?vue&type=template&id=3ae6f58f&scoped=true&"
import script from "./triage.vue?vue&type=script&lang=js&"
export * from "./triage.vue?vue&type=script&lang=js&"
import style0 from "./triage.vue?vue&type=style&index=0&id=3ae6f58f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6f58f",
  null
  
)

export default component.exports